import * as React from 'react'
import { useCurrentRoute } from 'react-navi'
import { defaultAppFn } from '../../utils/app'

import { Cookie } from 'src/utils/cookie'
import { JWT } from 'src/utils/jwt'
import { WXShareConfig } from 'src/utils/config'

interface IProp {
    id: string
}

const style = { padding: "1rem", lineHeight: "2rem" }

const ActivityRule: React.SFC<IProp> = (props) => {
    const data = useCurrentRoute()
    const brief = data.data.brief.replace(/\n/g, "<br>")

    defaultAppFn.Apply('app_nav', {
        show: true,
        back: true,
        title: data.data.name,
        share: false
    })

    // 微信分享设置
    const jwt = JWT.decode(Cookie.get())
    WXShareConfig(
        `${jwt ? jwt.user_name : ''}邀请您参加上海有色网投票活动`,
        '参加上海有色网投票活动，领取精彩奖励',
        window.location.href,
        'https://imgqn.smm.cn/production/hybrid/exkOj20190703111132.png'
    )

    return (
        <div style={style} dangerouslySetInnerHTML={{ __html: brief }} />
    )
}

export {
    ActivityRule
}


// WEBPACK FOOTER //
// ./src/components/activity_rule/rule.tsx